// client/src/pages/Weddings/steps/DessertsStep/components/DessertTabs.jsx
import React from "react";
import { Box, Tabs, Tab, Chip, Stack, Skeleton } from "@mui/material";

export default function DessertTabs({
  loading,
  subcatWithCounts,
  activeSubcat,
  setActiveSubcat,
}) {
  if (loading) {
    return (
      <Box sx={{ mb: 3 }}>
        <Skeleton variant="rectangular" height={42} />
      </Box>
    );
  }
  if (!subcatWithCounts.length) return null;

  return (
    <Box
      sx={(t) => ({
        position: "sticky",
        top: 0,
        zIndex: 1,
        bgcolor: t.palette.background.paper,
        borderBottom: `1px solid ${t.palette.divider}`,
        mb: 3,
      })}>
      <Tabs
        value={activeSubcat}
        onChange={(_, v) => setActiveSubcat(v)}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        aria-label="Patisserie subcategories"
        sx={{
          "& .MuiTab-root": {
            opacity: 0.85,
            textTransform: "none",
            minHeight: 42,
          },
          "& .Mui-selected": {
            opacity: 1,
            color: (t) => t.palette.primary.main,
          },
          "& .MuiTabs-indicator": {
            backgroundColor: (t) => t.palette.primary.main,
          },
          "& .MuiTabs-scrollButtons": {
            display: { xs: "flex", sm: "none" },
            color: "text.secondary",
            opacity: 0.7,
            "&.Mui-disabled": { opacity: 0.3 },
          },
        }}>
        {subcatWithCounts.map(({ key, label, count, selected }) => (
          <Tab
            key={key}
            value={key}
            label={
              <Stack direction="row" alignItems="center" spacing={1}>
                <span>{label}</span>
                <Chip
                  size="small"
                  variant="outlined"
                  label={count}
                  sx={{
                    height: 20,
                    "& .MuiChip-label": { px: 0.75, fontSize: 12 },
                  }}
                />
                {selected > 0 && (
                  <Chip
                    size="small"
                    color="primary"
                    label={selected}
                    sx={{
                      height: 18,
                      "& .MuiChip-label": {
                        px: 0.5,
                        fontSize: 11,
                        fontWeight: 700,
                      },
                    }}
                  />
                )}
              </Stack>
            }
          />
        ))}
      </Tabs>
    </Box>
  );
}
